"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createViewUrl = void 0;
const api_1 = __importDefault(require("../../lib/api"));
function createViewUrl(props) {
    const { isDocument = false, getUrl } = props;
    const token = props.token || api_1.default.getAccessToken() || '';
    const proxyURL = new URL(getUrl(token), api_1.default.getBaseUrl());
    if (isDocument) {
        const params = new URLSearchParams({ src: proxyURL.toString() });
        return new URL(`https://view.officeapps.live.com/op/view.aspx?${params.toString()}`);
    }
    return proxyURL;
}
exports.createViewUrl = createViewUrl;
//# sourceMappingURL=createViewUrl.js.map